import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { ReactComponent as LogoSvg } from 'resources/svg/logo.svg'
import { NewsletterForm } from './components/NewsletterForm'
import { Contact } from './components/Contact'
import { FAQs } from './components/FAQs'
import { FooterLinks } from './components/FooterLinks'
import { LegalLinks } from './components/LegalLinks'
import { Container, FooterLogo } from './components/Styled'

export const Footer = () => {
  const { pathname } = useLocation()
  const isProductSelector = pathname.includes('product-selector/questions') || pathname.includes('product-selector/results')

  if (isProductSelector) {
    return null
  }

  return (
    <Container>
      <div>
        <NewsletterForm />
        <div className='footer__main-column'>
          <Contact />
          <FAQs />
          <FooterLinks />
        </div>
        <FooterLogo>
          <Link to='/'>
            <LogoSvg />
          </Link>
        </FooterLogo>
        <LegalLinks />
      </div>
    </Container>
  )
}
